import "./Links.scss";

function Next() {
  return (
    <>
      <div className="frame-121">
        <div className="next">
          <span> Next</span>
        </div>
      </div>
    </>
  );
}

export default Next;